import util from '@/libs/util.js'
import storejs from 'store'
import {
    AccountLogin
} from '@/api/sys.login'
import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        login({
            dispatch
        }, {
            mobile,
            password,
            randomString,
            uuids,
            state,
            VerificationCode,
        }) {
            return new Promise((resolve, reject) => {
                // 开始请求登录接口
                AccountLogin({
                    mobile,
                    password,
                    randomString,
                    uuids,
                    state,
                    VerificationCode
                    })
                    .then(async res => {
                        console.log('res', res)
                        if (res.code === 0) {
                            util.cookies.set('uuid', res.t.uuid);
                            util.cookies.set('token', res.t.token);
                            //把权限写入storejs
                            let permissionsArr = []
                            res.t.trees.forEach(element => {
                                permissionsArr.push(element.name)
                            });
                            res.t.password = password
                            res.t.username = mobile
                            console.log('userInfo', res.t)
                            storejs.set('permissions', permissionsArr);
                            storejs.set('publicData', res.t);
                            // 设置 vuex 用户信息
                            await dispatch('d2admin/user/set',
                                res.t, {
                                    root: true
                                })
                            debugger
                            resolve(res)
                        } else {
                            reject(res)
                        }
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        /**
         * @description 注销用户并返回登录页面
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param confirm {Boolean} 是否需要确认
         */
        logout({
            commit
        }, {
            vm,
            confirm = false
        }) {
            /**
             * @description 注销
             */
            async function logout() {
                await axios.post("/logout")
                // 删除cookie
                util.cookies.remove('token')
                util.cookies.remove('uuid')
                // 跳转路由
                vm.$router.push({
                    name: 'login'
                });
            }
            // 判断是否需要确认
            if (confirm) {


            } else {
                logout()
            }
        },
        load({
            commit,
            dispatch
        }) {
            return new Promise(async resolve => {
                // DB -> store 加载用户名
                await dispatch('d2admin/user/load', null, {
                    root: true
                })
                resolve()
            })
        }

    }
}